<template>
<v-app>


 <div style="margin-top: 70px; max-width:680px; margin: auto; background-color: white; padding-left: 50px; padding-right:50px; padding-bottom: 50px;">
        <div class="text-center">
           <img style="margin:0 auto;" width="300px;" src="https://scarlettnetwork.com/wp-content/uploads/2019/03/Scarlett_Logo_Colour.png" />
        </div>
    
        <div style="font-size:1rem">
            <h3 style="margin-bottom: 15px;font-size:1.3em">Scheduled maintenance for Saturday July 16, 2022.</h3>
            <p>Please note that system is currently unavailable due to a scheduled service maintenance window. System is expected to be back up and running by 6:00 AM ET on Saturday July 16, 2022.</p>
            <p>If you have any questions or concerns, please contact our support team after 6:00 AM on Saturday July 16, 2022.</p>
            <p>
                Email: <a href="mailto:support@scarlettnetwork.com">support@scarlettnetwork.com</a><br />
                Telephone: 1.855.561.4399 / option: 2
            </p>
            <p>We apologize for any inconvenience this may cause and thank you for your patience and cooperation.</p>
            <p>
                Sincerely,<br />
                Scarlett Network Team<br />
                Advanced Delivery Systems | Axiom Innovations Inc.<br />
                5160 Yonge St. Suite 1006, Toronto, ON, M2N 6L9<br />
                Office: 1.855.561.4399 | E-mail:  <a href="mailto:support@scarlettnetwork.com">support@scarlettnetwork.com</a>
            </p>
        </div>
    </div>


</v-app>    







</template>

<script>
export default {

}
</script>
 